import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './VideoGallery.module.css';

interface VideoGalleryProps {
  t: (key: string) => string;
}

const VideoGallery: React.FC<VideoGalleryProps> = ({ t }) => {
  const navigate = useNavigate();

  // Sample videos from Kingdom Studio - Replace URLs with your actual videos
  const sampleVideos = [
    {
      title: t('videoGallery.video1.title'),
      url: "YOUR_VIDEO_URL_HERE_1.mp4", // Replace with actual video URL
      thumbnail: "YOUR_THUMBNAIL_URL_1.jpg", // Optional thumbnail
      category: t('videoGallery.video1.category'),
      duration: t('videoGallery.video1.duration'),
      description: t('videoGallery.video1.description')
    },
    {
      title: t('videoGallery.video2.title'),
      url: "YOUR_VIDEO_URL_HERE_2.mp4", // Replace with actual video URL
      thumbnail: "YOUR_THUMBNAIL_URL_2.jpg",
      category: t('videoGallery.video2.category'),
      duration: t('videoGallery.video2.duration'),
      description: t('videoGallery.video2.description')
    },
    {
      title: t('videoGallery.video3.title'),
      url: "YOUR_VIDEO_URL_HERE_3.mp4", // Replace with actual video URL
      thumbnail: "YOUR_THUMBNAIL_URL_3.jpg",
      category: t('videoGallery.video3.category'),
      duration: t('videoGallery.video3.duration'),
      description: t('videoGallery.video3.description')
    },
    {
      title: t('videoGallery.video4.title'),
      url: "YOUR_VIDEO_URL_HERE_4.mp4", // Replace with actual video URL
      thumbnail: "YOUR_THUMBNAIL_URL_4.jpg",
      category: t('videoGallery.video4.category'),
      duration: t('videoGallery.video4.duration'),
      description: t('videoGallery.video4.description')
    },
    {
      title: t('videoGallery.video5.title'),
      url: "YOUR_VIDEO_URL_HERE_5.mp4", // Replace with actual video URL
      thumbnail: "YOUR_THUMBNAIL_URL_5.jpg",
      category: t('videoGallery.video5.category'),
      duration: t('videoGallery.video5.duration'),
      description: t('videoGallery.video5.description')
    },
    {
      title: t('videoGallery.video6.title'),
      url: "YOUR_VIDEO_URL_HERE_6.mp4", // Replace with actual video URL
      thumbnail: "YOUR_THUMBNAIL_URL_6.jpg",
      category: t('videoGallery.video6.category'),
      duration: t('videoGallery.video6.duration'),
      description: t('videoGallery.video6.description')
    }
  ];

  return (
    <section className={styles.videoGallery}>
      <div className={styles.galleryHeader}>
        <h2 className={styles.galleryTitle}>{t('videoGallery.title')}</h2>
        <p className={styles.gallerySubtitle}>
          {t('videoGallery.subtitle')}
        </p>
      </div>

      <div className={styles.galleryGrid}>
        {sampleVideos.map((video, index) => (
          <div key={index} className={styles.galleryItem}>
            <div className={styles.videoWrapper}>
              <video
                className={styles.video}
                src={video.url}
                poster={video.thumbnail}
                controls
                preload="metadata"
              >
                Your browser does not support the video tag.
              </video>
              <div className={styles.videoOverlay}>
                <span className={styles.videoDuration}>{video.duration}</span>
                <span className={styles.videoCategory}>{video.category}</span>
              </div>
            </div>
            <div className={styles.videoInfo}>
              <h3 className={styles.videoTitle}>{video.title}</h3>
              <p className={styles.videoDescription}>{video.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.galleryCTA}>
        <p className={styles.galleryCtaText}>
          {t('videoGallery.ctaText')}
        </p>
        <button 
          className={styles.galleryCtaButton}
          onClick={() => navigate('/create-content')}
        >
          {t('videoGallery.ctaButton')}
        </button>
      </div>
    </section>
  );
};

export default VideoGallery;
